module.exports = __webpack_public_path__ + "static/media/illy-512.687b45dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/illy-512.png
// module id = 772
// module chunks = 0